export default "__VITE_ASSET__9c140737__"